export const ASSET_CSS =  "/assets/css";
export const ASSET_IMAGES =  "/assets/img";
export const ASSET_ICONS =  "/assets/icons";

const ANIMAL_IMAGE = ASSET_IMAGES + "/animal";
const AVATAR_IMAGE = ASSET_IMAGES + "/avatar";
const CREATEPAGE = ASSET_IMAGES + "/createPage";
const MAINPAGE = ASSET_IMAGES + "/main";
const FINANCEPAGE = ASSET_IMAGES + "/finance";
const MAIN = ASSET_IMAGES + "/";
export const animalAssets = {
  active_animal: `${ANIMAL_IMAGE}/active_animal.png`,
  animal_avatar: `${ANIMAL_IMAGE}/animal_avatar.png`,
  checked: `${ANIMAL_IMAGE}/checked.png`,
  ic_add: `${ANIMAL_IMAGE}/ic_add.png`,
  ic_arrow_down: `${ANIMAL_IMAGE}/ic_arrow_down.png`,
  ic_arrow_right: `${ANIMAL_IMAGE}/ic_arrow_right.png`,
  ic_arrow_up: `${ANIMAL_IMAGE}/ic_arrow_up.png`,
  ic_banner: `${ANIMAL_IMAGE}/ic_banner.png`,
  ic_checked: `${ANIMAL_IMAGE}/ic_checked.png`,
  ic_close: `${ANIMAL_IMAGE}/ic_close.png`,
  ic_edit: `${ANIMAL_IMAGE}/ic_edit.png`,
  ic_editable: `${ANIMAL_IMAGE}/ic_editable.png`,
  ic_editable_inactive: `${ANIMAL_IMAGE}/ic_editable_inactive.png`,
  ic_eye: `${ANIMAL_IMAGE}/ic_eye.png`,
  ic_eye_active: `${ANIMAL_IMAGE}/ic_eye_active.png`,
  ic_help: `${ANIMAL_IMAGE}/ic_help.png`,
  ic_help_active: `${ANIMAL_IMAGE}/ic_help_active.png`,
  ic_inject: `${ANIMAL_IMAGE}/ic_inject.png`,
  ic_modal_checkbtn: `${ANIMAL_IMAGE}/ic_modal_checkbtn.png`,
  ic_modal_disable: `${ANIMAL_IMAGE}/ic_modal_disable.png`,
  ic_modal_ok: `${ANIMAL_IMAGE}/ic_modal_ok.png`,
  ic_service: `${ANIMAL_IMAGE}/ic_service.png`,
  ic_setting: `${ANIMAL_IMAGE}/ic_setting.png`,
  ic_setting_active: `${ANIMAL_IMAGE}/ic_setting_active.png`,
  ic_show: `${ANIMAL_IMAGE}/ic_show.png`,
  ic_title: `${ANIMAL_IMAGE}/ic_title.png`,
  ic_user: `${ANIMAL_IMAGE}/ic_user.png`,
  ic_user1: `${ANIMAL_IMAGE}/ic_user1.png`,
  inactive_animal: `${ANIMAL_IMAGE}/inactive_animal.png`,
  logo: `${ANIMAL_IMAGE}/logo.png`,
  sidebar_footer: `${ANIMAL_IMAGE}/sidebar_footer.png`,
};

export const avatarAssets = {
  Icon_cat_1: `${AVATAR_IMAGE}/Icon_cat_1.png`,
  Icon_cat_2: `${AVATAR_IMAGE}/Icon_cat_2.png`,
  Icon_dog_1: `${AVATAR_IMAGE}/Icon_dog_1.png`,
  Icon_dog_2: `${AVATAR_IMAGE}/Icon_dog_2.png`,
  Icon_ferret_1: `${AVATAR_IMAGE}/Icon_ferret_1.png`,
  Icon_ferret_2: `${AVATAR_IMAGE}/Icon_ferret_2.png`,
  Icon_generic_1: `${AVATAR_IMAGE}/Icon_generic pet_1.png`,
  Icon_generic_2: `${AVATAR_IMAGE}/Icon_generic pet_2.png`,
}

export const createAssets = {
  Icon_close: `${CREATEPAGE}/Icon_close.png`,
  icon_error: `${CREATEPAGE}/icon_error.png`,
  Icon_save: `${CREATEPAGE}/Icon_save.png`,
}

export const mainAssets = {
  ic_1: `${MAINPAGE}/ic_1.png`,
  ic_2: `${MAINPAGE}/ic_2.png`,
  ic_3: `${MAINPAGE}/ic_3.png`,
  ic_home: `${MAINPAGE}/ic_home.png`,
  ic_security: `${MAINPAGE}/ic_security.png`,
  Logo: `${MAINPAGE}/Logo.png`,

  logo_bg: `${MAIN}/logo_bg.png`,
  MediPet_loading: `${MAIN}/MediPet_loading.gif`,
  warn: `${MAIN}/warn.png`,

}

export const cssAssets = {
    login: `${ASSET_CSS}/login.css`,
    component: `${ASSET_CSS}/component.css`,

}

export const financeAssets = {
  alert_info: `${FINANCEPAGE}/alert-info.png`,
  ic_arrach: `${FINANCEPAGE}/ic-arrach.png`,
  ic_complete: `${FINANCEPAGE}/ic-complete.png`,
  ic_download: `${FINANCEPAGE}/ic-download.png`,
  ic_edit: `${FINANCEPAGE}/ic-edit.png`,
  ic_error: `${FINANCEPAGE}/ic-error.png`,
  ic_info: `${FINANCEPAGE}/ic-info.png`,
  ic_info_active: `${FINANCEPAGE}/ic-info-active.png`,
  ic_pending: `${FINANCEPAGE}/ic-pending.png`,
  ic_sidebar: `${FINANCEPAGE}/ic-sidebar.png`,
  ic_1: `${FINANCEPAGE}/ic-1.png`,
  ic_3: `${FINANCEPAGE}/ic-3.png`,
  ic_2: `${FINANCEPAGE}/ic-2.png`,
}
export const scrollTop = () => {
  window.scrollTo(0, 0);
};
